var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSelectChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 14,
  fill: "none",
  viewBox: "0 0 25 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m2.213 0 10.162 9.405L22.537 0l2.213 2.047L12.375 13.5 0 2.048z"
})));
export default SvgSelectChevronDown;